import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index'
import Login from '../views/tologin/index'
import Analysis from '../views/analysis/index'
import Data from '../views/data/index'
import GetVersion from '../plugins/version'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const routes = [{
    path: '/',
    component: () => import('./../views/introduction/index')
  },
  {
    path: '/tologin',
    name: 'Login',
    component: Login
  },
  {
    path: '/introduction',
    component: () => import('./../views/introduction/index')
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/analysis',
    name: 'Analysis',
    component: Analysis
  },
  {
    path: '/studyroom',
    name: 'Studyroom',
    component: () => import('./../views/studyroom/index')
  },
  {
    path: '/data',
    component: Data,
    children: [{
        path: 'source',
        component: () => import('./../views/data/source/index')
      },
      {
        path: 'generation',
        component: () => import('./../views/data/generation/index')
      },
      {
        path: 'comparison',
        component: () => import('./../views/data/comparison/index')
      },
      {
        path: 'putaway',
        component: () => import('./../views/data/putaway/index')
      },
      {
        path: 'result',
        component: () => import('./../views/data/result/index')
      }
    ]
  },
  {
    path: '/systemmanager',
    component: () => import('../views/systemmanager/index'),
    children: [{
        path: 'historical',
        component: () => import('../views/systemmanager/historical/index')
      },
      {
        path: 'system',
        component: () => import('../views/systemmanager/system/index')
      },
      {
        path: 'systemExperiment',
        component: () => import('../views/systemmanager/systemExperiment/index')
      },
      {
        path: 'systemTotal',
        component: () => import('../views/systemmanager/total/index')
      },
    ]
  },
  {
    path: '/simulation',
    name: 'Simulation',
    component: () => import('./../views/simulation/index')
  },
  {
    path: '/simulationComparison',
    name: 'SimulationComparison',
    component: () => import('./../views/simulationComparison/index')
  },
  {
    path: '/simulationPutaway',
    name: 'SimulationPutaway',
    component: () => import('./../views/simulationPutaway/index')
  },
  {
    path: '/OptimizationProduct',
    name: 'OptimizationProduct',
    component: () => import('./../views/optimizationProduct/index')
  },
  {
    path: '/sellerdecision',
    name: 'SellerDecision',
    component: () => import('./../views/sellerDecision/index')
  },
  {
    path: '/customerService',
    name: 'customerService',
    component: () => import('./../views/customerService/index')
  },
  {
    path: '/simulationResult',
    name: 'SimulationResult',
    component: () => import('./../views/simulationResult/index')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  try {
    GetVersion()
  } catch (e) {
    console.log(e)
  }
  next()
})

export default router